<template>
  <div class="record-page">
    <!-- KPI -->
    <div class="kpi-row">
      <div class="kpi-card" v-for="item in kpiList" :key="item.key">
        <div class="kpi-icon" :class="item.cls">&#9632;</div>
        <div class="kpi-info">
          <div class="kpi-label">{{ item.label }}</div>
          <div class="kpi-value" :style="{ color: item.color }">
            {{ stats[item.key] }}<span class="kpi-unit">{{ item.unit }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 筛选 -->
    <div class="filter-bar">
      <el-form :inline="true" :model="formInline" @submit.native.prevent>
        <el-form-item label="老人姓名">
          <el-input v-model.trim="formInline.oldmanName" placeholder="请输入姓名" clearable style="width:130px" />
        </el-form-item>
        <el-form-item label="设备编号">
          <el-input v-model.trim="formInline.deviceNo" placeholder="如 XS542382" clearable style="width:130px" />
        </el-form-item>
        <el-form-item label="服药状态">
          <el-select v-model="formInline.takeMedicine" placeholder="全部" clearable style="width:110px">
            <el-option :value="1" label="已服药" />
            <el-option :value="2" label="漏服" />
            <el-option :value="3" label="重复开盒" />
          </el-select>
        </el-form-item>
        <el-form-item label="记录日期">
          <el-date-picker v-model="formInline.dateRange" type="daterange" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width:240px" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" :loading="loading" @click="loadList">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格 -->
    <div v-loading="loading" element-loading-text="加载中...">
      <el-table :data="list" style="width:100%" border :row-style="tableRowStyle" :header-cell-style="tableHeaderColor">
        <el-table-column label="老人信息" min-width="150">
          <template slot-scope="scope">
            <div style="display:flex;align-items:center;gap:8px">
              <div class="avatar">{{ scope.row.oldmanName ? scope.row.oldmanName.charAt(0) : '?' }}</div>
              <div>
                <div style="font-weight:500">{{ scope.row.oldmanName || '-' }}</div>
                <div style="font-size:11px;color:#909399">{{ scope.row.location }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="设备编号" prop="deviceNo" width="130" align="center" />
        <el-table-column label="提醒时间" prop="remindTime" width="160" align="center" />
        <el-table-column label="开盒时间" width="160" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.operateTime">{{ scope.row.operateTime }}</span>
            <span v-else style="color:#c0c4cc">—</span>
          </template>
        </el-table-column>
        <el-table-column label="服药状态" width="110" align="center">
          <template slot-scope="scope">
            <el-tag :type="getTakeStatusType(scope.row.takeMedicine)" size="mini">
              {{ getTakeStatusLabel(scope.row.takeMedicine) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="餐次" width="90" align="center">
          <template slot-scope="scope">{{ getMealLabel(scope.row.mealType) }}</template>
        </el-table-column>
        <el-table-column label="电量" width="70" align="center">
          <template slot-scope="scope">
            <span :style="{ color: getBatteryColor(scope.row.battery) }">
              {{ scope.row.battery != null ? scope.row.battery + '%' : '-' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="信号" width="70" align="center">
          <template slot-scope="scope">{{ getSignalLabel(scope.row.signalStrength) }}</template>
        </el-table-column>
      </el-table>

      <el-pagination background layout="total, prev, pager, next, sizes" :total="total"
        :page-size="pageSize" :page-sizes="[10, 20, 50]" :current-page="pageNum"
        @current-change="handlePageChange" @size-change="handleSizeChange" class="fenye" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      pageNum: 1,
      pageSize: 20,
      formInline: {
        oldmanName: '',
        deviceNo: '',
        takeMedicine: undefined,
        dateRange: [],
      },
      stats: { todayTake: 0, todayMiss: 0, repeatOpen: 0, compliance: 0 },
      kpiList: [
        { key: 'todayTake',  label: '今日已服',  unit: '次', cls: 'kpi-green',  color: '#67c23a' },
        { key: 'todayMiss',  label: '今日漏服',  unit: '次', cls: 'kpi-red',    color: '#f56c6c' },
        { key: 'repeatOpen', label: '重复开盒',  unit: '次', cls: 'kpi-orange', color: '#e6a23c' },
        { key: 'compliance', label: '今日依从率', unit: '%',  cls: 'kpi-blue',   color: '#409eff' },
      ],
    };
  },
  methods: {
    loadList() {
      this.loading = true;
      const groupId = sessionStorage.getItem('groupId') || undefined;
      this.$postJson('dmc/medicine/box/upload/list', {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        groupId: groupId ? Number(groupId) : undefined,
        oldmanName: this.formInline.oldmanName || undefined,
        deviceNo: this.formInline.deviceNo || undefined,
        takeMedicine: this.formInline.takeMedicine,
        startTime: this.formInline.dateRange && this.formInline.dateRange[0]
          ? this.formInline.dateRange[0] + ' 00:00:00' : undefined,
        endTime: this.formInline.dateRange && this.formInline.dateRange[1]
          ? this.formInline.dateRange[1] + ' 23:59:59' : undefined,
      }).then(res => {
        const data = res.result || res;
        this.list = data.list || [];
        this.total = Number(data.total) || 0;
      }).finally(() => { this.loading = false; });

      this.$postJson('dmc/medicineBox/todayStats', { groupId: groupId ? Number(groupId) : undefined }).then(res => {
        const data = res.result || res;
        if (data) Object.assign(this.stats, data);
      });
    },
    resetForm() {
      this.formInline = { oldmanName: '', deviceNo: this.$route.query.deviceNo || '', takeMedicine: undefined, dateRange: [] };
      this.pageNum = 1;
      this.loadList();
    },
    handlePageChange(val) { this.pageNum = val; this.loadList(); },
    handleSizeChange(val) { this.pageSize = val; this.pageNum = 1; this.loadList(); },
    getTakeStatusLabel(v) {
      return { 1: '已服药', 2: '漏服', 3: '重复开盒' }[v] || '-';
    },
    getTakeStatusType(v) {
      return { 1: 'success', 2: 'danger', 3: 'warning' }[v] || 'info';
    },
    getMealLabel(v) {
      const map = {
        breakfast_before: '早餐前', breakfast_after: '早餐后',
        lunch_before: '午餐前', lunch_after: '午餐后',
        dinner_before: '晚餐前', dinner_after: '晚餐后',
        bedtime: '睡前', other: '其他',
      };
      return map[v] || v || '-';
    },
    getBatteryColor(v) {
      if (v == null) return '#909399';
      return v <= 20 ? '#f56c6c' : v <= 50 ? '#e6a23c' : '#67c23a';
    },
    getSignalLabel(v) {
      if (v == null) return '-';
      return v <= 5 ? '极弱' : v <= 10 ? '弱' : v <= 20 ? '中' : '强';
    },
    tableRowStyle({ rowIndex }) {
      return rowIndex % 2 === 0 ? 'background:#fff' : 'background:#e4f5f8';
    },
    tableHeaderColor({ rowIndex }) {
      if (rowIndex === 0) return 'color:#2d2d2d;font-weight:600;font-size:14px;background:#d4f5fa;';
    },
  },
  created() {
    this.formInline.deviceNo = this.$route.query.deviceNo || '';
    this.formInline.oldmanName = this.$route.query.oldmanName || '';
    this.loadList();
  },
};
</script>

<style lang="scss" scoped>
.record-page { padding: 10px 5px; }

.kpi-row {
  display: flex; gap: 12px; margin-bottom: 16px; flex-wrap: wrap;
}
.kpi-card {
  flex: 1; min-width: 140px;
  display: flex; align-items: center; gap: 12px;
  padding: 12px 16px;
  background: #fff; border-radius: 6px; border: 1px solid #ebeef5;
  box-shadow: 0 1px 4px rgba(0,0,0,.06);
}
.kpi-icon {
  width: 36px; height: 36px; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-size: 14px; flex-shrink: 0;
}
.kpi-blue   { background: #ecf5ff; color: #409eff; }
.kpi-green  { background: #f0f9eb; color: #67c23a; }
.kpi-orange { background: #fdf6ec; color: #e6a23c; }
.kpi-red    { background: #fef0f0; color: #f56c6c; }
.kpi-label  { font-size: 12px; color: #909399; }
.kpi-value  { font-size: 22px; font-weight: 700; color: #303133; }
.kpi-unit   { font-size: 12px; font-weight: 400; color: #909399; margin-left: 2px; }

.filter-bar { margin-bottom: 12px; }

.avatar {
  width: 28px; height: 28px; border-radius: 50%;
  background: #ecf5ff; color: #409eff;
  display: flex; align-items: center; justify-content: center;
  font-size: 12px; font-weight: 600; flex-shrink: 0;
}

.fenye { margin: 20px 0; text-align: right; }
</style>
